/* Keep focus cues for keyboard navigation without leaving rings after taps. */
(function () {
  'use strict';
  const root = document.documentElement;
  if (root.hasAttribute('data-cu-focus-input')) return;
  root.dataset.cuFocusInput = 'pointer';
  document.addEventListener('pointerdown', () => {
    root.dataset.cuFocusInput = 'pointer';
  }, true);
  document.addEventListener('keydown', event => {
    if (event.altKey || event.ctrlKey || event.metaKey) return;
    if (['Tab', 'Enter', ' ', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) {
      root.dataset.cuFocusInput = 'keyboard';
    }
  }, true);
}());
